export default __webpack_public_path__ + "static/media/sector-building.7c4cd3d7.png";